import React, { useRef, useState } from 'react'
import { ExpandMore, KeyboardArrowRight, Add, LocalSee } from "@mui/icons-material";
import { Button, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import colorConfigs from '../../../configs/colorConfigs';
import axios from 'axios';
import baseURL from '../../../configs/api';
import { Dialog, DialogContent } from '@mui/material';
import Webcam from 'react-webcam';
import ReactQuill from 'react-quill';
import { handleCapture } from '../../../utils/covertTheBase64FormatIntoImage';
import { useTheme } from '../../../components/hooks/useTheme';
import EmailValidatedComponent from '../../../components/EmailValidatedComponent';
import Cookies from 'js-cookie';
import useTenant from '../../../components/hooks/useTenant';

const modules = {
    toolbar: [
        [{ font: [] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        [{ script: "sub" }, { script: "super" }],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }, { align: [] }],
        ["link", "image", "video"],
        ["clean"],
    ],
};

type Props = {
    isPretendEmails: string;
    setIsPretendEmails: (value: string) => void;
    replyToEmail: string;
    setReplyToEmail: (value: string) => void;
    isDisabledSmsFailureNotificationEmails: string;
    setIsDisabledSmsFailureNotificationEmails: (value: string) => void;
    emailForFailureNotifications: string;
    setEmailForFailureNotifications: (value: string) => void;
    mainLayout: string;
    setMainLayout: (value: string) => void;
    emailSignature: string;
    setEmailSignature: (value: string) => void;
    mailFooter: string;
    setMailFooter: (value: string) => void;
    isShowLogoOnEmails: string;
    setIsShowLogoOnEmails: (value: string) => void;
    mailBarColor: string;
    setMailBarColor: (value: string) => void;
    emailFilePath: string;
    setEmailFilePath: (value: string) => void;
    baseUrl: string;
    setBaseUrl: (value: string) => void;
    setPleaseWaitPopup: (value: boolean) => void;
    showWebcam: boolean;
    setShowWebcam: (value: boolean) => void;
    disabled: boolean;
};

const EmailSettings = ({
    isPretendEmails,
    setIsPretendEmails,
    replyToEmail,
    setReplyToEmail,
    isDisabledSmsFailureNotificationEmails,
    setIsDisabledSmsFailureNotificationEmails,
    emailForFailureNotifications,
    setEmailForFailureNotifications,
    mainLayout,
    setMainLayout,
    emailSignature,
    setEmailSignature,
    mailFooter,
    setMailFooter,
    isShowLogoOnEmails,
    setIsShowLogoOnEmails,
    mailBarColor,
    setMailBarColor,
    emailFilePath,
    setEmailFilePath,
    baseUrl,
    setBaseUrl,
    setPleaseWaitPopup,
    showWebcam,
    setShowWebcam,
    disabled
}: Props) => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { handleTenantError }: any = useTenant();
    const { themeStyles } = useTheme();
    const [isEmailSettings, setIsEmailSetttings] = useState<boolean>(true);

    const webRef = useRef(null);
    const inputFileRef = useRef<HTMLInputElement>(null);
    const onFileChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPleaseWaitPopup(true);
        const selectedFiles = e.target.files as FileList;

        if (selectedFiles.length !== 0) {
            const formData = new FormData();
            formData.append("ImageFile", selectedFiles[0]);

            axios
                .post(`${baseURL}commonFile/upload`, formData, {
                    headers: {
                        'X-Tenant-ID': tenantId,
                        "Content-Type": "multipart/form-data"
                    },
                    withCredentials: true,
                })
                .then((response) => {
                    setEmailFilePath(response.data);
                    setPleaseWaitPopup(false);
                    handleTenantError(null);
                })
                .catch((error) => {
                    handleTenantError(error);
                });

        } else {
            setPleaseWaitPopup(false);
        }
    };

    const handleWebsiteBaseUrlChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setBaseUrl(value);
        const isValid = /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#-]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/gm.test(value);
        e.target.setCustomValidity(isValid ? '' : 'Please enter a valid website URL');
    };

    return (
        <div>
            <h5 className="mb-0 flex justify-start items-center cursor-pointer select-none"
                onClick={() => setIsEmailSetttings(!isEmailSettings)}
            >
                {isEmailSettings ? (
                    <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                ) : (
                    <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                )}{" "}

                <div style={{ color: themeStyles.topBar.textColor }}>Email Settings</div>
            </h5>
            <hr />

            {isEmailSettings &&
                <div className="w-full px-2 pt-4">
                    <div className="grid grid-cols-2 gap-4">
                        <div className="space-y-4">
                            <div>
                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Pretend Emails?</label>
                                <RadioGroup
                                    row
                                    value={isPretendEmails}
                                    onChange={(e) => setIsPretendEmails(e.target.value)}
                                >
                                    <FormControlLabel
                                        value="Yes" control=
                                        {<Radio
                                            disabled={disabled}
                                            sx={{
                                                color: "gray",
                                                "&.Mui-checked": { color: "#167AC3" },
                                                "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                                "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                            }}
                                        />} label="Yes"
                                        sx={{
                                            "& .MuiFormControlLabel-label": {
                                                color: themeStyles.form.labelTextColor,
                                            },
                                            "&.Mui-disabled .MuiFormControlLabel-label": {
                                                color: themeStyles.form.labelTextColor,
                                            },
                                        }}
                                    />
                                    <FormControlLabel value="No" control={
                                        <Radio
                                            disabled={disabled}
                                            sx={{
                                                color: "gray",
                                                "&.Mui-checked": { color: "#167AC3" },
                                                "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                                "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                            }}
                                        />} label="No"
                                        sx={{
                                            "& .MuiFormControlLabel-label": {
                                                color: themeStyles.form.labelTextColor,
                                            },
                                            "&.Mui-disabled .MuiFormControlLabel-label": {
                                                color: themeStyles.form.labelTextColor,
                                            },
                                        }}
                                    />
                                </RadioGroup>
                            </div>

                            <div>
                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Disable SMS failure notification emails?</label>
                                <RadioGroup
                                    row
                                    value={isDisabledSmsFailureNotificationEmails}
                                    onChange={(e) => setIsDisabledSmsFailureNotificationEmails(e.target.value)}
                                >
                                    <FormControlLabel
                                        value="Yes" control=
                                        {<Radio
                                            disabled={disabled}
                                            sx={{
                                                color: "gray",
                                                "&.Mui-checked": { color: "#167AC3" },
                                                "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                                "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                            }}
                                        />} label="Yes"
                                        sx={{
                                            "& .MuiFormControlLabel-label": {
                                                color: themeStyles.form.labelTextColor,
                                            },
                                            "&.Mui-disabled .MuiFormControlLabel-label": {
                                                color: themeStyles.form.labelTextColor,
                                            },

                                        }}
                                    />
                                    <FormControlLabel value="No" control={
                                        <Radio
                                            disabled={disabled}
                                            sx={{
                                                color: "gray",
                                                "&.Mui-checked": { color: "#167AC3" },
                                                "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                                "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                            }}
                                        />} label="No"
                                        sx={{
                                            "& .MuiFormControlLabel-label": {
                                                color: themeStyles.form.labelTextColor,
                                            },
                                            "&.Mui-disabled .MuiFormControlLabel-label": {
                                                color: themeStyles.form.labelTextColor,
                                            },
                                        }}
                                    />
                                </RadioGroup>
                            </div>

                            <div>
                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Mail Layout</label>
                                <input
                                    type="text"
                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                    value={mainLayout}
                                    disabled={disabled}
                                    onChange={(e) => setMainLayout(e.target.value)}
                                    required
                                />
                            </div>
                        </div>

                        <div className="space-y-4">
                            <div>
                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Reply To (Email)</label>
                                <EmailValidatedComponent
                                    text={replyToEmail}
                                    setText={setReplyToEmail}
                                    required={true}
                                    disabled={disabled}
                                />
                            </div>

                            <div>
                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Email for Failure Notifications</label>
                                <EmailValidatedComponent
                                    text={emailForFailureNotifications}
                                    setText={setEmailForFailureNotifications}
                                    required={true}
                                    disabled={disabled}
                                />
                            </div>

                            <div className="pt-2">
                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Website Baseurl</label>
                                <input
                                    type="text"
                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                    value={baseUrl}
                                    disabled={disabled}
                                    onChange={handleWebsiteBaseUrlChange}
                                    required
                                />
                            </div>
                        </div>
                    </div>

                    <div className="w-full flex pt-[1rem]">
                        <div className={`flex w-[62px] border !border-b-0 ${themeStyles.form.tailwindLabelTextColor} text-center p-[5px] !pb-0 text-[0.75rem]`}>
                            English
                        </div>

                        <div className={`w-full border-b ${themeStyles.form.tailwindLabelTextColor}`} />
                    </div>

                    <div className="w-full flex gap-[1rem] mt-[0.625rem]">
                        <div className="flex-1">
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Email Signature</label>
                            <ReactQuill
                                style={{ height: "150px", width: "100%" }}
                                theme="snow"
                                value={emailSignature}
                                modules={modules}
                                onChange={setEmailSignature}
                                readOnly={disabled}
                            />
                        </div>

                        <div className="flex-1">
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Mail Footer</label>
                            <ReactQuill
                                style={{ height: "150px", width: "100%" }}
                                theme="snow"
                                value={mailFooter}
                                modules={modules}
                                onChange={setMailFooter}
                                readOnly={disabled}
                            />
                        </div>
                    </div>

                    <div className="w-full flex flex-row gap-4 mt-[124px]">
                        <div className="w-1/2 flex flex-row">
                            <div className="w-1/2">
                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Mail Bar Logo</label>
                                <div
                                    style={{
                                        maxWidth: "50%",
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center",
                                        gap: "5px",
                                    }}
                                >
                                    {emailFilePath &&
                                        <>
                                            <img
                                                src={emailFilePath.startsWith("data:image/png") ?
                                                    emailFilePath
                                                    :
                                                    `${baseURL}commonFile/Get?name=${emailFilePath}`}
                                                width={40}
                                                height={40}
                                                alt="mailBarLogo"
                                            />
                                        </>
                                    }
                                </div>
                                <input
                                    type="file"
                                    accept="image/*"
                                    name="mailBarLogo"
                                    ref={inputFileRef}
                                    disabled={disabled}
                                    onChangeCapture={onFileChangeCapture}
                                    style={{ display: "none" }}
                                />
                                <div className="flex flex-row gap-2 mt-2">
                                    <p
                                        className="border border-dashed border-black rounded-sm px-1.5 py-0.5 flex justify-center items-center text-xs bg-white cursor-pointer"
                                        onClick={(e) => {
                                            if (inputFileRef.current !== null) {
                                                inputFileRef.current.value = "";

                                            }
                                            inputFileRef.current?.click();
                                        }}
                                    >
                                        {" "}
                                        <Add className="text-sm text-[#167AC3] font-bold" />
                                        Add Image
                                    </p>

                                    <p className="border border-dashed border-black rounded-sm px-1.5 py-0.5 flex justify-center items-center text-xs bg-white cursor-pointer"
                                        onClick={() => setShowWebcam(true)}
                                    >
                                        {" "}
                                        <LocalSee fontSize="small" className="text-sm text-[#167AC3] font-bold" />
                                    </p>
                                </div>
                            </div>

                            <div>
                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Pretend Emails?</label>
                                <RadioGroup
                                    row
                                    value={isShowLogoOnEmails}
                                    onChange={(e) => setIsShowLogoOnEmails(e.target.value)}
                                >
                                    <FormControlLabel
                                        value="Yes" control=
                                        {<Radio
                                            disabled={disabled}
                                            sx={{
                                                color: "gray",
                                                "&.Mui-checked": { color: "#167AC3" },
                                                "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                                "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                            }}
                                        />} label="Yes"
                                        sx={{
                                            "& .MuiFormControlLabel-label": {
                                                color: themeStyles.form.labelTextColor,
                                            },
                                            "&.Mui-disabled .MuiFormControlLabel-label": {
                                                color: themeStyles.form.labelTextColor,
                                            },

                                        }}
                                    />
                                    <FormControlLabel value="No" control={
                                        <Radio
                                            disabled={disabled}
                                            sx={{
                                                color: "gray",
                                                "&.Mui-checked": { color: "#167AC3" },
                                                "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                                "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                            }}
                                        />} label="No"
                                        sx={{
                                            "& .MuiFormControlLabel-label": {
                                                color: themeStyles.form.labelTextColor,
                                            },
                                            "&.Mui-disabled .MuiFormControlLabel-label": {
                                                color: themeStyles.form.labelTextColor,
                                            },
                                        }}
                                    />
                                </RadioGroup>
                            </div>
                        </div>

                        <div className="flex flex-col">
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Main Bar Color</label>
                            <input
                                type="color"
                                name="mailBarColor"
                                style={{
                                    fontSize: "14px",
                                }}
                                value={mailBarColor}
                                disabled={disabled}
                                onChange={(e) => setMailBarColor(e.target.value)}
                            />

                        </div>
                    </div>
                </div>
            }

            <Dialog
                open={showWebcam && !disabled}
                maxWidth="md"
                fullScreen={false}
                PaperProps={{
                    style: {
                        marginTop: "-16%",
                    },
                }}
            >
                <DialogContent sx={{ padding: "0px" }}>
                    <Webcam
                        width={480}
                        height={320}
                        ref={webRef}
                        screenshotFormat="image/png"
                        audio={false}
                        disabled={disabled}
                    />

                    <div className="w-full h-[50px] flex flex-row justify-between py-2 px-4 bg-[#eeeeee]">
                        <div style={{ width: "50%" }}>
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: "#e0dee0",
                                    color: colorConfigs.sidebar.color,
                                    borderRadius: "0",
                                    border: "none",
                                    textTransform: "capitalize",
                                    fontSize: "12px",
                                    "&: hover": {
                                        backgroundColor: "#e0dee0",
                                        color: colorConfigs.sidebar.color,
                                    },
                                }}
                                onClick={() => setShowWebcam(false)}
                            >
                                Cancel
                            </Button>
                        </div>

                        <div className="w-1/2 flex flex-row justify-end">
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: colorConfigs.topbar.bg,
                                    color: "white",
                                    borderRadius: "0",
                                    border: "none",
                                    textTransform: "capitalize",
                                    fontSize: "12px",
                                    "&: hover": {
                                        backgroundColor: colorConfigs.topbar.bg,
                                        color: "white",
                                    },
                                }}
                                onClick={() => {
                                    if (webRef.current !== null) {
                                        //@ts-ignore
                                        const imageSrc = webRef.current.getScreenshot();

                                        handleCapture(imageSrc, `${baseURL}commonFile/upload`, tenantId, (imageFilePath: string) => {
                                            if (imageFilePath) {
                                                setEmailFilePath(imageFilePath);
                                            }
                                        })

                                        setShowWebcam(false);
                                    }
                                }}
                            >
                                Capture an Image
                            </Button>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default EmailSettings